import type {
  BuildCaregiverApplicationRequestInput,
  CaregiverApplicationRequest,
} from "./types/caregiver-application";

function buildCaregiverApplicationRequest(
  input: BuildCaregiverApplicationRequestInput,
): CaregiverApplicationRequest {
  const { step2, source, trackingCookies } = input;

  return {
    application: {
      jobId: step2.jobID,
      officeId: step2.organizationNumber,
      userEnteredLocation: step2.userEnteredLocation,
    },
    consent: {
      email: step2.OptInEmail,
      sms: step2.OptInSms,
      terms: true,
    },
    contact: {
      email: step2.Email,
      firstName: step2.FirstName,
      lastName: step2.LastName,
      phone: step2.Phone,
      postalCode: step2.postalCode,
    },
    eligibility: {
      businessInEnglish: step2.BusinessInEnglish,
      canWorkInUS: step2.CanWorkInUS,
    },
    source,
    tracking: {
      cookies: trackingCookies,
    },
  };
}

type LegacyFlatCaregiverPayload = {
  FirstName?: string;
  LastName?: string;
  Email?: string;
  Phone?: string;
  postalCode?: string;
  organizationNumber?: number;
  franchiseNumber?: number;
  jobID?: string;
  userEnteredLocation?: string;
  CanWorkInUS?: boolean;
  BusinessInEnglish?: boolean;
  OptInEmail?: boolean;
  OptInSms?: boolean;
  sourcePrimary?: string;
  sourceSub?: string;
  sourceType?: string;
  sourceURL?: string | null;
  sourceOther?: string;
  TrackingCookie?: Record<string, string>[];
};

function buildCaregiverApplicationRequestFromFlatPayload(
  payload: LegacyFlatCaregiverPayload,
): CaregiverApplicationRequest {
  const officeId = payload.organizationNumber ?? payload.franchiseNumber;

  if (officeId === undefined) {
    throw new Error(
      "Legacy caregiver payload missing organizationNumber or franchiseNumber",
    );
  }

  return buildCaregiverApplicationRequest({
    source: {
      other: payload.sourceOther ?? "",
      primary: payload.sourcePrimary ?? "",
      sub: payload.sourceSub ?? "",
      type: payload.sourceType ?? "",
      url: payload.sourceURL ?? null,
    },
    step2: {
      BusinessInEnglish: payload.BusinessInEnglish ?? false,
      CanWorkInUS: payload.CanWorkInUS ?? false,
      Email: payload.Email ?? "",
      FirstName: payload.FirstName ?? "",
      jobID: payload.jobID ?? "",
      LastName: payload.LastName ?? "",
      OptInEmail: payload.OptInEmail ?? true,
      OptInSms: payload.OptInSms ?? false,
      organizationNumber: officeId,
      Phone: payload.Phone ?? "",
      postalCode: payload.postalCode ?? "",
      userEnteredLocation: payload.userEnteredLocation ?? "",
    },
    trackingCookies: payload.TrackingCookie ?? [],
  });
}

export {
  buildCaregiverApplicationRequest,
  buildCaregiverApplicationRequestFromFlatPayload,
};
